import { useState } from 'react';
import { Box, Pagination } from 'components/ui';
import { useQuery } from '@apollo/client/react';
import { usePaginate } from 'contexts/paginate';
import { useError } from 'contexts/error';
import InspectionResultsQuery from 'queries/inspection_result/index';
import Index from 'components/inspection_result/index';

const IndexContainer = ({ inspectionId }) => {
  const { page, onPageChange } = usePaginate();
  const setError = useError();
  const [sortBy, setSortBy] = useState('done_at_desc');
  const {
    data = { inspectionResults: { inspectionResults: [], inspectionResultsTotalPages: 0 } },
    loading,
  } = useQuery(InspectionResultsQuery, {
    variables: {
      inspectionId,
      page,
      sortBy,
    },
    fetchPolicy: 'cache-and-network',
    onError: () => {
      setError('error.inspection_result.index');
    },
  });

  return (
    <>
      <Index
        loading={loading}
        inspectionResults={data.inspectionResults}
        sortBy={sortBy}
        onSortChange={setSortBy}
      />
      <Box display="flex" justifyContent="center">
        {data.inspectionResults.inspectionResultsTotalPages > 1 && (
          <Pagination
            count={data.inspectionResults.inspectionResultsTotalPages}
            page={page}
            onChange={(_e, nextPage) => {
              onPageChange(nextPage);
            }}
          />
        )}
      </Box>
    </>
  );
};

export default IndexContainer;
